import { render } from "./SidebarProfile.vue?vue&type=template&id=934a36b8&scoped=true&lang=pug"
import script from "./SidebarProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarProfile.vue?vue&type=script&setup=true&lang=js"

import "./SidebarProfile.vue?vue&type=style&index=0&id=934a36b8&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934a36b8"]])

export default __exports__